module.exports = __webpack_public_path__ + "img/Questionnaire@2x_EN.346a9e9b.png";